var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIcPinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.405 0C2.535 0 1.83.705 1.83 1.575v10.85c0 .87.705 1.575 1.575 1.575h7.62c.87 0 1.575-.705 1.575-1.575V4.471c0-.792-.585-1.447-1.346-1.558V1.575C11.254.705 10.549 0 9.679 0H3.405z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.809 1.69c0-.4.324-.724.724-.724h5.17c.8 0 1.449.648 1.449 1.448h-6.62a.724.724 0 0 1-.723-.724z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 7.118c0-1.6 1.356-2.894 2.996-2.894 1.645 0 3.001 1.294 3.001 2.894 0 .806-.297 1.555-.787 2.19-.54.7-1.205 1.31-1.954 1.788-.172.11-.326.119-.515 0a7.593 7.593 0 0 1-1.954-1.789c-.49-.634-.787-1.383-.787-2.19zm2.009.09c0 .536.443.957.987.957.545 0 .992-.421.992-.958a.99.99 0 0 0-.992-.974.986.986 0 0 0-.987.974z",
    fill: "url(#c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1.83,
    y1: 0,
    x2: 1.83,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2.809,
    y1: 0.966,
    x2: 2.809,
    y2: 2.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 4.4,
    y1: 4.224,
    x2: 4.4,
    y2: 11.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcPinDark);
export default __webpack_public_path__ + "static/media/icon-ic-pin-dark.49cbb67d.svg";
export { ForwardRef as ReactComponent };